import request from "../infra/request";

export const fetchRawReferrals = async (source) => {
  try {
    const response = await request.get("/admin/incoming-referrals/raw", { headers: { source } });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const deleteReferralById = async ({ id, source }) => {
  try {
    const response = await request.delete(`/admin/incoming-referrals/raw/${id}?source=${source}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

// PATCH /admin/incoming-referrals/raw/:id/speciality — source is a query param here,
// unlike fetchRawReferrals, which sends it as a header.
export const assignReferralSpecialityPath = (id, source) =>
  `/admin/incoming-referrals/raw/${encodeURIComponent(id)}/speciality?source=${encodeURIComponent(source)}`;

// "" puts the referral back in the Unassigned folder.
export const assignReferralSpeciality = async ({ id, specialityName, source }) => {
  try {
    const response = await request.patch(assignReferralSpecialityPath(id, source), {
      specialityName,
    });
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};
